import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements AfterViewInit {
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;
  @Input() message: string;
  @Input() confirmText: string = $localize`Продолжить`;
  @Input() cancelText: string = $localize`Отмена`;
  @Output() done = new EventEmitter<boolean>();

  constructor(public dialog: MatDialog) {}

  ngAfterViewInit(): void {
    const dialogRef = this.dialog.open(this.dialogTemplate);
    dialogRef
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (data) => {
          this.done.emit(data);
        },
      });
  }
}
